import React from "react";
import PropTypes from "prop-types";
import { CopyToClipboard } from "react-copy-to-clipboard";

import Modal from "../Modal";

const ViewCopyLink = ({ url, visible, onClose, onDone }) => (
  <Modal title="Calendar Sync" visible={visible} onClose={onClose}>
    <div>
      <p className="grey-text">
        To subscribe to your calendar, copy the link below into your calendar
        software. <a className="calander-sync-link" href='https://help.digiquatics.com/en/articles/2199075-can-i-sync-my-schedule-with-google-or-apple-calendar'
        target="_blank">Click here</a> for more information on adding your schedule 
        to third-party calendars. For the most current information about your schedule, we
        recommend viewing your upcoming shifts directly in DigiQuatics as schedule 
        changes may take up to 24 hours to be reflected in third-party calendars.
      </p>
      <br />

      <div>
        <label>My Schedule ICS Link</label>

        <input className="form-control" title="link copy" value={url} onChange={() => {}} />
      </div>
      <br />
      <div>
        <CopyToClipboard text={url} onCopy={onDone}>
          <a tabIndex={0} href="#" className="btn btn-pink btn-block btn-raised">COPY TO CLIPBOARD</a>
        </CopyToClipboard>

        <a tabIndex={0} href="#" className="btn btn-grey btn-block btn-raised" onClick={onClose}>
          CLOSE
        </a>
      </div>
    </div>
  </Modal>
);

ViewCopyLink.propTypes = {
  url: PropTypes.string,
  visible: PropTypes.bool,
  onClose: PropTypes.func,
  onDone: PropTypes.func
};

export default ViewCopyLink;
